import { Equipment, EquipmentType, Extractor, RotationType } from "@/models/equipment.model";
import { Component, Prop, Vue } from "vue-property-decorator";
import store from "@/store";
import useVuelidate, { Validation } from "@vuelidate/core";
import { maxValue, minLength, minValue, required } from "@vuelidate/validators";
import { computed, Data, ref, SetupContext } from "@vue/composition-api";
@Component({
  components: {},
  setup(props: Data, context: SetupContext) {
    //Formulaire
    const customName = ref("");
    const customMinFlow = ref(0);
    const customBaseFlow = ref(0);
    //Only for extractors
    const customMinExtraction = ref(0);
    const customMaxExtraction = ref(0);
    const customRotationType = ref(RotationType.variable);

    const minDepression: number = store.state.settingsModule.settings.minimalDepressionValue;

    const baseDepression: number = store.state.settingsModule.settings.depressionValuetoMaintain;

    function isExtractor(): boolean {
      return props.equipmentType === EquipmentType.extractor;
    }

    /**
     * Create a new object equipment based on the 2 custom fields and send it to parent component.
     */
    function saveCustomEquipment(): void {
      const custumEquipmentLabel = store.state.equipmentsModule.customEquipmentLabel;

      const customEquipment: Equipment | Extractor = {
        id: "custom_" + customName.value,
        completeName: custumEquipmentLabel.replace("{completeName}", customName.value),
        model: customName.value,
        constructor: "",
        description: customName.value,
        order: 0,
        image: {
          path: Vue.prototype.customEquipmentImg,
          alt: props.customAlt as string, //We use a prop as a hack to get value from i18n in setup
        },
        type: EquipmentType.custom,
        rotation_type: customRotationType.value,
        minimumExtraction: customMinExtraction.value,
        maximumExtraction: customMaxExtraction.value,
        abacus: [
          { y: 0, x: 0 },
          { y: customMinFlow.value, x: minDepression },
          { y: customBaseFlow.value, x: baseDepression },
        ],
      };
      context.emit("customEquipmentSelected", customEquipment);
    }
    //Validation rules for custom equipment.
    const rules: any = {
      //always applied
      customName: {
        required,
        minLength: minLength(3),
      },
    };
    //Adding corresponding validators only if it's an extractor.
    if (isExtractor()) {
      rules.customMinExtraction = {
        required,
        minimum: minValue(1),
        maximum: maxValue(customMaxExtraction),
      };
      rules.customMaxExtraction = {
        required,
        minimum: minValue(customMinExtraction),
      };
      rules.customRotationType = {
        required,
      };
      //Adding validators if it's not an extractor.
    } else {
      rules.customMinFlow = {
        required,
        minimum: minValue(1),
        maximum: maxValue(customBaseFlow),
      };
      rules.customBaseFlow = {
        required,
        minimum: minValue(customMinFlow),
      };
    }

    return {
      v: useVuelidate(
        rules,
        {
          customName,
          customMinFlow,
          customBaseFlow,
          customMinExtraction,
          customMaxExtraction,
          customRotationType,
        },
        { $scope: false }
      ),
      customName,
      customMinFlow,
      customBaseFlow,
      customMinExtraction,
      customMaxExtraction,
      customRotationType,
      minDepression,
      baseDepression,
      isExtractor: computed(isExtractor),
      saveCustomEquipment: saveCustomEquipment,
    };
  },
})
export default class CustomEquipmentSelector extends Vue {
  @Prop() equipmentType!: EquipmentType;
  @Prop() customAlt!: string;

  v!: Validation;
  tooltipHelpFlowMinimalValue = this.$sanitize(
    this.$t("help.equipmentPage.equipmentSelectorSection.flowMinimalValue").toString()
  );
  tooltipHelpFlowMaximalValue = this.$sanitize(
    this.$t("help.equipmentPage.equipmentSelectorSection.flowMaximalValue").toString()
  );

  rotationModeOptions = [
    {
      value: RotationType.variable,
      text: this.$t("components.equipmentPage.equipmentDisplay.rotationVariable").toString(),
    },
    {
      value: RotationType.set,
      text: this.$t("components.equipmentPage.equipmentDisplay.rotationSet").toString(),
    },
  ];

  get breakpoint(): string {
    return this.$screen.breakpoint || "sm";
  }
}
